// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { AsyncButtonEl } from 'common/components/async-button';
import { SelectTheme } from 'common/components/select/constants';
import { SelectEl } from 'common/components/select';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonTheme } from 'common/components/button/constants';
import { getHost } from 'common/util/url';
import { CopyToClipboardButtonEl } from 'common/widgets/copy-to-clipboard/copy-to-clipboard-button';
import { CopyType } from 'common/widgets/copy-to-clipboard/copy-to-clipboard-button/types';
import { PublicDashboardPasswordRowEl } from 'common/widgets/public-dashboard-password-row';
export enum OverflowActions {
  Deactivate = "Deactivate",
  Edit = "Edit Passcode",
}
export const getPublicDashboardLinkOverflowButton = (_ref, changeHandler) => {
  let {
    workspaceId,
    dashboardId,
    canEdit
  } = _ref;
  return <>
      <SelectEl attrs={{
      theme: SelectTheme.Secondary,
      elref: "publicDashboardLinkOverflow_".concat(workspaceId),
      icon: {
        leftIcon: "hor-ellipsis"
      },
      options: [OverflowActions.Edit, OverflowActions.Deactivate],
      'icon-only': true,
      'menu-width': 125,
      disabled: !canEdit
    }} on={{
      change: ev => changeHandler(ev, {
        dashboardId,
        workspaceId
      })
    }} data-sentry-element="SelectEl" data-sentry-source-file="mixins.tsx" />
      {!canEdit && <TooltipEl attrs={{
      'max-width': "300px"
    }}>
          You don't have access to edit this board or links
        </TooltipEl>}
    </>;
};
export const getPublicDashboardLink = _ref2 => {
  let {
    publicLink,
    passwordProtected
  } = _ref2;
  const href = "/p/".concat(publicLink);
  const fullHref = "".concat(getHost()).concat(href);
  return <div sel='.public-dashboard-link-mixin' data-sentry-component="getPublicDashboardLink" data-sentry-source-file="mixins.tsx">
      <span sel='.public-dashboard-link-container'>
        <a sel='.public-dashboard-link' attrs={{
        href,
        target: "_blank"
      }}>
          {"p/".concat(publicLink)}
        </a>
        {passwordProtected && <div sel='.public-dashboard-link-subtext'> passcode protected </div>}
        <TooltipEl attrs={{
        'max-width': "400px"
      }} data-sentry-element="TooltipEl" data-sentry-source-file="mixins.tsx">
          {fullHref}
        </TooltipEl>
      </span>
      <CopyToClipboardButtonEl attrs={{
      options: [{
        value: fullHref
      }],
      theme: ButtonTheme.Tertiary,
      'copy-type': CopyType.Link
    }} sel='.public-dashboard-link-copy-btn' data-sentry-element="CopyToClipboardButtonEl" data-sentry-source-file="mixins.tsx" />
    </div>;
};
export const getPublicDashboardLinkDeactivateButton = (_ref3, deleteCallback) => {
  let {
    workspaceId,
    canDeactivate
  } = _ref3;
  return <>
      <AsyncButtonEl params={{
      asyncAction: () => deleteCallback(workspaceId.toString()),
      theme: ButtonTheme.Secondary,
      elref: "publicDashboardLinkDeactivate_".concat(workspaceId),
      icon: "trashcan",
      disabled: !canDeactivate
    }} data-sentry-element="AsyncButtonEl" data-sentry-source-file="mixins.tsx" />
      <TooltipEl attrs={{
      'max-width': "300px"
    }} data-sentry-element="TooltipEl" data-sentry-source-file="mixins.tsx">
        {canDeactivate ? "Deactivate Public Link" : "You don't have access to edit this board or links"}
      </TooltipEl>
    </>;
};
export const LinkDetailMixin = onPasswordChange => {
  return row => {
    return <PublicDashboardPasswordRowEl attrs={{
      'workspace-id': row.workspaceId,
      'public-link-id': row.publicLink,
      'password-protected': row.passwordProtected,
      'public-link-embed-link-with-passcode': row.embedLink
    }} on={{
      passwordChange: onPasswordChange
    }} key={row.publicLink} />;
  };
};